import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * Enable product quick view on product tiles
 */
export const FE_ENABLE_PRODUCT_QUICK_VIEW_250924 = experiment({
  name: "FE_ENABLE_PRODUCT_QUICK_VIEW_250924",
  identifier: "RetailerTokenInSession",
  client: ["RETAILER"],
  notifyAfter: "2026-01-10",
  defaultValue: "disabled",
  productArea: "PRODUCT_TILE",
});
